import { useState } from "react";

const isUserLogin = () => {
  const isUserLoggedIn = getLoggedinUser();
  let isUserSigned = false;
  if(isUserLoggedIn){
    isUserSigned = true;
  }

  return isUserSigned ;
};

export { isUserLogin };


const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};